import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { isBefore } from 'date-fns';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import Keycloak from 'keycloak-js';
import { environment } from 'src/environments/environment';

class AuthResult{
  token: string;
  expires_at: Date;
}

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private readonly keycloak = inject(Keycloak);

  constructor(private readonly http: HttpService) { }


  public Login(userEmail: string, password: string): Observable <boolean> {
    return new Observable<boolean>( observer => {
      
      this.http.post('Authentication/JwtLogin', { Username: userEmail, Password: password })
      .subscribe((result: AuthResult) => {
        console.log(result);
        this.setSession(result);
        observer.next(this.isLoggedIn());
      },
      (error: HttpErrorResponse)=>{
        if(401 == error.status){
          observer.next(false);
        }
        else{
          observer.error(error);
        }
      })

    });
  } 

  private setSession(result: AuthResult) {
    var expirationDate = new Date(result.expires_at);

    localStorage.setItem('id_token', result.token);
    localStorage.setItem("expires_at", JSON.stringify(expirationDate.valueOf()) );
  }          

  isTokenExpired(): boolean {
    return this.keycloak.isTokenExpired();
  }

  /**
   * Clears all authentication-related data from localStorage.
   * Can be called before any logout operation.
   */
  public clearAuthStorage(): void {
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("Keycloaktoken");
  }

  logout() {
    this.clearAuthStorage();
    
    // Build Keycloak logout URL from environment configuration
    const logoutUrl = `${environment.keycloakUrl}${environment.keycloakLogoutPath}?post_logout_redirect_uri=${encodeURIComponent(environment.postLogoutRedirectUri)}&client_id=${environment.clientId}`;
    
    window.location.href = logoutUrl;
  }

  public isLoggedIn():boolean {
    return isBefore(new Date(), this.getExpiration());
  }

  public isLoggedOut(): boolean {
      return !this.isLoggedIn();
  }

  public getToken():string{
    return localStorage.getItem("Keycloaktoken");
  }

  private getExpiration(): Date {
    const expiration = localStorage.getItem("expires_at");
    const expiresAt = JSON.parse(expiration);
    return new Date(expiresAt);
}    


}
